import defaultState, { ChannelReducerDefaultState } from './defaultState'
import { actionTypes } from '../../../actions/src'
import { ReduxAction } from '../../reducerType'

const updateChannelManagers = (data, updatedData) => {

  let newData:any = []

  data.forEach((datum) => {

    if (datum.id === updatedData.id) {

      newData.push(updatedData)

    } else {

      newData.push(datum)

    }

  })

  return newData
  
}

const updateNewChannelManagers = (data, newData) => {

  return [...data, ...newData]
  
}

const removeChannelManagers = (data, managerId) => {

  let newData:any = []

  data.forEach((datum) => {

    if (datum.id !== managerId) {

      newData.push(datum)

    }

  })

  return newData
  
}

const channelReducer = (state: ChannelReducerDefaultState = defaultState, { type, payload }: ReduxAction): ChannelReducerDefaultState => {

  switch (type) {

    case actionTypes.FETCH_CHANNEL_DATA:
      return {
        ...state,
        status: {
          ...state.status,
          errorResponse: {},
          hasData: false,
          hasError: false,
          isFetching: true
        },
        data: {
          ...defaultState.data,
          id: payload
        }
      }
    case actionTypes.FETCH_CHANNEL_DATA_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          errorResponse: {},
          hasData: true,
          hasError: false,
          isFetching: false
        },
        data: {
          ...defaultState.data,
          ...payload
        }

      }
    case actionTypes.FETCH_CHANNEL_DATA_ERROR:
      return {
        ...state,
        status: {
          ...state.status,
          errorResponse: payload,
          hasData: false,
          hasError: true,
          isFetching: false
        }
      }
    case actionTypes.FETCH_CHANNEL_MANAGERS:
      return {
        ...state,
        managers: {
          ...state.managers,
          inProgress: true
        }
      }
    case actionTypes.FETCH_CHANNEL_MANAGERS_SUCCESSFUL:
        return {
          ...state,
          managers: {
            ...state.managers,
            inProgress: false,
            data: payload.data,
            error: null,
            total: payload.total
          }
        }
    case actionTypes.FETCH_CHANNEL_MANAGERS_FAILED:
      return {
        ...state,
        managers: {
          ...state.managers,
          inProgress: false,
          data: [],
          error: payload,
          total: 0
        }
      }
    case actionTypes.ADD_CHANNEL_MANAGERS:
      return {
        ...state,
        managers: {
          ...state.managers,
          addingInProgress: true,
          addingStatus: 'ADDING',
          addingErrors: null,
          added: 0
        }
      }
    case actionTypes.ADD_CHANNEL_MANAGERS_SUCCESSFUL:
      return {
        ...state,
        managers: {
          ...state.managers,
          addingInProgress: false,
          addingStatus: payload.errors && payload.errors.length > 0 ? 'PARTIAL' : 'SUCCESS',
          addingErrors: payload.errors,
          data: updateNewChannelManagers(state.managers.data, payload.data),
          added: payload.data.length,
          total: state.managers.total
        }
      }
    case actionTypes.ADD_CHANNEL_MANAGERS_FAILED:
      return {
        ...state,
        managers: {
          ...state.managers,
          addingInProgress: false,
          addingStatus: payload.code === 'MaxChannelManagersExceeded' ? 'MAX_MANAGERS_EXCEEDED' :
            (payload.code === 'Conflict' && payload.statusCode === 409) ? 'CHANNEL_MANAGER_ALREADY_EXIST' : 'FAILED',
          addingErrors: payload.errors,
          added: 0,
          errorMessage: payload.message
        }
      }
    case actionTypes.UPDATE_CHANNEL_MANAGERS:
      return {
        ...state,
        managers: {
          ...state.managers,
          inProgress: true,
        }
      }
    case actionTypes.UPDATE_CHANNEL_MANAGERS_SUCCESSFUL:
        return {
          ...state,
          managers: {
            ...state.managers,
            inProgress: false,
            data: updateChannelManagers(state.managers.data, payload)
          }
        }
    case actionTypes.UPDATE_CHANNEL_MANAGERS_FAILED:
      return {
        ...state,
        managers: {
          ...state.managers,
          inProgress: false
        }
      }
    case actionTypes.REVOKE_CHANNEL_MANAGERS:
      return {
        ...state,
        managers: {
          ...state.managers,
          revokeInProgress: true,
        }
      }
    case actionTypes.REVOKE_CHANNEL_MANAGERS_SUCCESSFUL:
      return {
        ...state,
        managers: {
          ...state.managers,
          revokeInProgress: false,
          data: removeChannelManagers(state.managers.data, payload)
        }
      }
    case actionTypes.REVOKE_CHANNEL_MANAGERS_FAILED:
      return {
        ...state,
        managers: {
          ...state.managers,
          revokeInProgress: false
        }
      }
    case actionTypes.RESET_CHANNEL_MANAGERS_DATA:
      return {
        ...state,
        managers: {
          ...defaultState.managers,
          data: state.managers.data,
          total: state.managers.total
        }
      }
    case actionTypes.UPDATE_CHANNEL_DATA:
      return {
        ...state,
        update: {
          inProgress: true,
          error: '',
          errorCode: '',
          status: 'updating'
        }
      }
    case actionTypes.UPDATE_CHANNEL_DATA_SUCCESSFUL:
      return {
        ...state,
        update: {
          inProgress: false,
          error: '',
          errorCode: '',
          status: 'success'
        }
      }
    case actionTypes.UPDATE_CHANNEL_DATA_FAILED:
      return {
        ...state,
        update: {
          inProgress: false,
          error: payload.message,
          errorCode: payload.code, 
          status: 'failed'
        }
      }
    case actionTypes.RESET_UPDATE_CHANNEL_DATA_FAILED:
      return {
        ...state,
        update: {
          inProgress: false,
          error: '',
          errorCode: '',
          status: 'not-updated'
        }
      }
    case actionTypes.FETCH_CHANNEL_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          inProgress: true,
          error: null
        }
      }
    case actionTypes.FETCH_CHANNEL_LIST_SUCCESS:
      return {
        ...state,
        list: {
          inProgress: false,
          error: null,
          data: payload.channels,
          total: payload.total
        }
      }
    case actionTypes.FETCH_CHANNEL_LIST_FAILED:
      return {
        ...state,
        list: {
          inProgress: false,
          error: payload,
          data: [],
          total: 0
        }
      }
    case actionTypes.CREATE_CHANNEL:
      return {
        ...state,
        create: {
          inProgress: true,
          error: null,
          status: 'CREATING',
          createdId: ''
        }
      }
    case actionTypes.CREATE_CHANNEL_SUCCESSFUL:
        return {
          ...state,
          create: {
            inProgress: false,
            error: null,
            status: 'SUCCESSFUL',
            createdId: payload.data.id
          }
        }
    case actionTypes.CREATE_CHANNEL_FAILED:
      return {
        ...state,
        create: {
          inProgress: false,
          error: payload.error,
          status: 'FAILED',
          createdId: ''
        }
      }
    case actionTypes.POST_BASIC_TEMPLATE_CREATION:
      return {
        ...state,
        logoUpload: {
          inProgress: true
        }
      }
    case actionTypes.POST_BASIC_TEMPLATE_CREATION_SUCCESS:
      return {
        ...state,
        logoUpload: {
          inProgress: false
        }
      }
    case actionTypes.POST_BASIC_TEMPLATE_CREATION_FAILED:
      return {
        ...state,
        logoUpload: {
          inProgress: false
        }
      }
    default:
      return state

  }

}

export default channelReducer
